import {
  EXCHANGE_AUTHORIZATION_CODE,
  REFRESH_TOKEN,
  LOGOUT,
} from "./actions.type";
import { AUTHENTICATE, DEAUTHENTICATE } from "./mutations.type";
import AuthService from "@/services/auth.service";

export default {
  [EXCHANGE_AUTHORIZATION_CODE]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AuthService.exchangeAuthorizationCode(payload)
        .then((data) => {
          commit(AUTHENTICATE, data);

          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [REFRESH_TOKEN]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AuthService.refreshToken(payload)
        .then((data) => {
          commit(AUTHENTICATE, data);

          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [LOGOUT]({ commit }) {
    commit(DEAUTHENTICATE);
  },
};
